import React from 'react'
import styled, { keyframes } from 'styled-components'
import Label from '../../../components/label/Label'
import { ICampPosition } from '../../../helpers/campPositionsHelper'
import Asset from '../../../components/asset/Asset'
import { IAssetData, FreezePosition } from '../../../helpers/data/assetData'

const Wrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	pointer-events: none;
`

const AvatarContainer = styled.div`
	width: 100%;
	height: 100%;
`

const HoverArea = styled.div`
	width: 50%;
	height: 70%;
	background-color: rgba(0, 0, 0, 0);
	position: absolute;
	top: 15%;
	left: 25%;
	pointer-events: all;
`

const enterAnim = keyframes`
  0% {
    opacity: 0;
    transform: translate(0, 20px);
    animation-timing-function: ease-out;
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
`

const exitAnim = keyframes`
  0% {
    opacity: 1;
    transform: translate(0, 0);
    animation-timing-function: ease-out;
  }
  100% {
    opacity: 0;
    transform: translate(0, -20px);
  }
`

const LabelContainer = styled.div`
	font-size: 20px;
	position: absolute;
	top: 0;
	right: 50%;
	&.toLeft {
		left: 50%;
	}
	&.enter {
		animation: ${enterAnim} 0.35s 1.5s;
		animation-fill-mode: both;
	}
	&.hover {
		animation: ${enterAnim} 0.35s 0s;
		animation-fill-mode: both;
	}
	&.exit {
		animation: ${exitAnim} 0.35s 0s;
		animation-fill-mode: both;
	}
`

export interface ICharacterState {
	label: string
}

export interface ICharacterProps {
	isHighlighted: boolean
	nickname: string
	asset: IAssetData
	pos: ICampPosition
	scale: number
	uid: string
	areAnimationsEnabled?: boolean
}

class CampCharacter extends React.PureComponent<ICharacterProps, ICharacterState> {
	private labelExitTimeout = 0

	static defaultProps = {
		scale: 1,
		uid: '',
	}

	state = {
		label: 'enter',
	}

	componentDidMount() {
		this.labelExitTimeout = window.setTimeout(() => {
			this.setState({
				label: 'exit',
			})
		}, 3000)
	}

	componentWillUnmount() {
		window.clearTimeout(this.labelExitTimeout)
	}

	handleOver = () => {
		window.clearTimeout(this.labelExitTimeout)
		this.setState({
			label: 'hover',
		})
	}

	handleOut = () => {
		window.clearTimeout(this.labelExitTimeout)
		this.setState({
			label: 'exit',
		})
	}

	handleClick = () => {
		window.clearTimeout(this.labelExitTimeout)
		this.setState({
			label: 'hover',
		})
		this.labelExitTimeout = window.setTimeout(() => {
			this.setState({
				label: 'exit',
			})
		}, 3000)
	}

	render() {
		const toLeft = this.props.pos[0] < 512
		let labelClass = toLeft ? 'toLeft' : ''
		if (this.state.label === 'exit' && !this.props.isHighlighted) {
			labelClass += ' exit'
		} else if (this.state.label === 'hover') {
			labelClass += ' hover'
		} else {
			labelClass += ' enter'
		}
		return (
			<Wrapper
				style={{
					transform: `translate(${this.props.pos[0] * this.props.scale}px,${this.props.pos[1] * this.props.scale}px)`,
					zIndex: Math.round(this.props.pos[1]),
				}}
			>
				<AvatarContainer
					style={{
						width: `${250 * this.props.scale}px`,
						height: `${250 * this.props.scale}px`,
					}}
				>
					<Asset asset={this.props.asset} uid={this.props.uid} areAnimationsEnabled={this.props.areAnimationsEnabled} freezePosition={FreezePosition.LastSegmentStart} />
				</AvatarContainer>
				<HoverArea onMouseOver={this.handleOver} onMouseOut={this.handleOut} onClick={this.handleClick} />
				<LabelContainer
					style={{
						fontSize: `${20 * this.props.scale}px`,
					}}
					className={labelClass}
				>
					<Label text={this.props.nickname} toLeft={toLeft} />
				</LabelContainer>
			</Wrapper>
		)
	}
}

export default CampCharacter
